module.exports = __webpack_public_path__ + "fonts/display-medium.ed9ac98e.woff";